const getAntiguedadPersonal = (fechaIngreso) => {
  let antiguedad = ''

  if (fechaIngreso) {
    const [day, month, year] = fechaIngreso.split('/').map(Number)
    const ingresoDate = new Date(year, month - 1, day)
    const now = new Date()
    antiguedad = now.getFullYear() - ingresoDate.getFullYear()

    const hasNotHadAnniversary =
      now.getMonth() < ingresoDate.getMonth() ||
      (now.getMonth() === ingresoDate.getMonth() && now.getDate() < ingresoDate.getDate())
    if (hasNotHadAnniversary) antiguedad--
    antiguedad = antiguedad >= 0 ? antiguedad : 0
  }

  return antiguedad
}

export default getAntiguedadPersonal
